// services/customerReportService.ts

import api from "../config/api";

export interface ReportParams {
    startDate: string;
    endDate: string;
    filterType: 'date' | 'range' | 'month' | 'year';
}

export interface CustomerReportResponse {
    success: boolean;
    data: {
        summary: {
            totalCustomers: number;
            newCustomersCount: number;
            activeCustomersCount: number;
            totalRevenue: number;
            avgRevenuePerCustomer: number;
        };
        newCustomers: any[];
        activeCustomers: any[];
        topSpenders: any[];
        genderDistribution: any[];
        dailyStats: any[];
        dateRange: {
            startDate: string;
            endDate: string;
        };
    };
}

export interface CourseReportResponse {
    success: boolean;
    data: {
        summary: {
            avgRevenueLAK: number;
            avgRevenueTHB: number;
            totalCoursesSold: number;
            totalRevenueLAK: number;
            totalRevenueTHB: number;
            totalSessions: number;
        };
        soldCourses: any[];
        popularCourses: any[];
        revenueByType: any[];
        dailyStats: any[];
        dateRange: {
            startDate: string;
            endDate: string;
        };
    };
}

export interface ActiveCoursesReportResponse {
    success: boolean;
    data: {
        summary: {
            totalActiveCourses: number;
            totalSessions: number;
            usedSessions: number;
            remainingSessions: number;
            usagePercentage: string;
        };
        activeCourses: any[];
        expiringCourses: any[];
        expiredCourses: any[];
        usageByType: any[];
        usageStats: any[];
        topCourseOwners: any[];
        dateRange: {
            startDate: string;
            endDate: string;
        };
    };
}

export const customerReportService = {
    // รายงานลูกค้า
    getCustomerReport: async (params: ReportParams) => {
        const response = await api.get('/reports/customers', { params });
        return response.data; // ✅ return เฉพาะ data.data ทันที
    },

    // รายงานคอร์ส
    getCourseReport: async (params: ReportParams): Promise<CourseReportResponse> => {
        const response = await api.get('/reports/courses', { params });
        return response.data;
    },

    // รายงานคอร์สกำลังใช้งาน
    getActiveCoursesReport: async (params: ReportParams): Promise<ActiveCoursesReportResponse> => {
        const response = await api.get('/reports/active-courses', { params });
        return response.data;

    }
};